var styles = {"message":"styles_message__uPypb","iconContainer":"styles_icon-container__U-qhC","compact":"styles_compact__hxnmn","vertical":"styles_vertical__xM1eK","actions":"styles_actions__2mDoU"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
